import React from 'react'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import { PinkLink, AppleIcon, PlayIcon } from './FaqStyledComponents'
import paypalConfirmMail from 'assets/images/faq/paypal_confirm_mail.png'
import paypalExampleMail from 'assets/images/faq/paypal_example_mail.png'
import paypalSetting from 'assets/images/faq/paypal-setting.png'

function openAppStore () {
  window.open('http://bit.ly/HausMartiOS', '_blank')
}

function openGooglePlay () {
  window.open('http://bit.ly/HausMartAndroid', '_blank')
}

export default {
  data: '22.06.2018',
  list: [
    {
      category: <FormattedMessage id='faq.categoryHeader.general' />,
      id: 'general',
      questions: [
        {
          id: 'faq.general.question9.question',
          question: <FormattedMessage id='faq.general.question9.question' />,
          answer: (
            <div>
              <FormattedMessage id='faq.hostSelling.question1-2.answer1' />
              <br />
              <br />
              <FormattedMessage id='faq.hostSelling.question1-2.answer2' />
              <br />
              <br />
              <FormattedMessage id='faq.hostSelling.question1-2.answer3' />
              <br />
              <br />
              <ul>
                <li>
                  <FormattedMessage id='faq.hostSelling.question1-2.answer3-1' />
                </li>
                <li>
                  <FormattedMessage id='faq.hostSelling.question1-2.answer3-2' />
                </li>
              </ul>
            </div>
          )
        },
        {
          id: 'faq.general.question1.question',
          question: <FormattedMessage id='faq.general.question1.question' />,
          answer: (
            <div>
              <FormattedMessage id='faq.general.question1.answer.part1' />
              <br />
              <br />
              <FormattedMessage id='faq.general.question1.answer.part2' />
            </div>
          )
        },
        {
          question: <FormattedMessage id='faq.general.question2.question' />,
          answer: (
            <div>
              <FormattedHTMLMessage id='faq.general.question2.answer' />
            </div>
          )
        },
        {
          question: <FormattedMessage id='faq.general.question3.question' />,
          answer: (
            <div>
              <FormattedMessage id='faq.general.question3.answer.part1' />
            </div>
          )
        },
        {
          question: <FormattedMessage id='faq.general.question4.question' />,
          answer: (
            <div>
              <FormattedMessage id='faq.general.question4.answer' />
              <br />
              <br />
              <FormattedMessage id='faq.general.question4.answer2' />
            </div>
          )
        },
        {
          id: 'faq.general.question5.question',
          question: <FormattedMessage id='faq.general.question5.question' />,
          answer: (
            <div>
              <FormattedMessage id='faq.general.question5.answer.part1' />
              <ul>
                <li>
                  <FormattedMessage id='faq.general.question5.answer.part3' />
                </li>
                <li>
                  <FormattedMessage id='faq.general.question5.answer.part4' />
                </li>
                <li>
                  <FormattedMessage id='faq.general.question5.answer.part5' />
                </li>
              </ul>
            </div>
          )
        },
        {
          id: 'faq.general.question6.question',
          question: <FormattedMessage id='faq.general.question6.question' />,
          answer: (
            <div>
              <span>
                <FormattedMessage id='faq.general.question6.answer.part1' />
              </span>
            </div>
          )
        },
        {
          id: 'faq.general.question7.question',
          question: <FormattedMessage id='faq.general.question7.question' />,
          answer: (
            <div>
              <FormattedMessage id='faq.general.question7.answer.part1' />
              <ul>
                <li>
                  <FormattedMessage id='faq.general.question7.answer.part2' />
                </li>
                <li>
                  <FormattedMessage id='faq.general.question7.answer.part3' />
                </li>
              </ul>
            </div>
          )
        },
        {
          question: <FormattedMessage id='faq.general.question8.question' />,
          answer: (
            <div>
              <FormattedMessage id='faq.general.question8.answer.part1' />
              <ul>
                <li>
                  <FormattedMessage id='faq.general.question8.answer.part2' />
                </li>
                <li>
                  <FormattedMessage id='faq.general.question8.answer.part3' />
                </li>
              </ul>
            </div>
          )
        }
      ]
    },
    {
      category: <FormattedMessage id='faq.categoryHeader.hostSelling' />,
      id: 'hostSelling',
      questions: [
        {
          id: 'faq.hostSelling.question1-2.question',
          question: (
            <FormattedMessage id='faq.hostSelling.question1-2.question' />
          ),
          answer: (
            <div>
              <FormattedMessage id='faq.hostSelling.question1-2.answer1' />
              <br />
              <br />
              <FormattedMessage id='faq.hostSelling.question1-2.answer2' />
            </div>
          )
        },
        {
          id: 'faq.hostSelling.question18.question',
          question: (
            <FormattedMessage id='faq.hostSelling.question18.question' />
          ),
          answer: (
            <div>
              <FormattedHTMLMessage id='faq.hostSelling.question18.answer' />
            </div>
          )
        },
        {
          id: 'faq.hostSelling.question1.question',
          question: (
            <FormattedMessage id='faq.hostSelling.question1.question' />
          ),
          answer: (
            <div>
              <FormattedMessage id='faq.hostSelling.question1.answer.part1' />
              <br />
              <br />
              <FormattedMessage id='faq.hostSelling.question1.answer.part2' />
              <br />
              <br />
              <ul>
                <li>
                  <FormattedMessage id='faq.hostSelling.question1.answer.part3' />
                </li>
                <li>
                  <FormattedMessage id='faq.hostSelling.question1.answer.part4' />
                </li>
                <li>
                  <FormattedMessage id='faq.hostSelling.question1.answer.part5' />
                </li>
                <li>
                  <FormattedMessage id='faq.hostSelling.question1.answer.part6' />
                </li>
              </ul>
            </div>
          )
        },
        {
          id: 'faq.hostSelling.question2.question',
          question: (
            <FormattedMessage id='faq.hostSelling.question2.question' />
          ),
          answer: (
            <div>
              <FormattedMessage id='faq.hostSelling.question2.answer' />
              <br />
              <br />
              <FormattedMessage id='homepage.downloadFrom' />{' '}
              <PinkLink onClick={openAppStore}>
                <AppleIcon /> <FormattedMessage id='homepage.appStore' />{' '}
              </PinkLink>{' '}
              <FormattedMessage id='general.or' />{' '}
              <PinkLink onClick={openGooglePlay}>
                <PlayIcon /> <FormattedMessage id='homepage.googlePlay' />
              </PinkLink>
            </div>
          )
        },
        {
          id: 'faq.hostSelling.question3.question',
          question: (
            <FormattedMessage id='faq.hostSelling.question3.question' />
          ),
          answer: (
            <div>
              <FormattedMessage id='faq.hostSelling.question3.answer.part1' />
              <br />
              <br />
              <FormattedMessage id='faq.hostSelling.question3.answer.part2' />
              <br />
              <br />
              <ul>
                <li>
                  <FormattedMessage id='faq.hostSelling.question3.answer.part3' />
                </li>
                <li>
                  <FormattedMessage id='faq.hostSelling.question3.answer.part4' />
                </li>
                <li>
                  <FormattedMessage id='faq.hostSelling.question3.answer.part5' />
                </li>
              </ul>
            </div>
          )
        },
        {
          id: 'faq.hostSelling.question3-1.question',
          question: (
            <FormattedMessage id='faq.hostSelling.question3-1.question' />
          ),
          answer: (
            <div>
              <FormattedMessage id='faq.hostSelling.question3-1.answer' />
            </div>
          )
        },
        {
          id: 'faq.hostSelling.question4.question',
          question: (
            <FormattedMessage id='faq.hostSelling.question4.question' />
          ),
          answer: (
            <div>
              <FormattedMessage id='faq.hostSelling.question4.answer' />
            </div>
          )
        },
        {
          id: 'faq.hostSelling.question5.question',
          question: (
            <FormattedMessage id='faq.hostSelling.question5.question' />
          ),
          answer: (
            <div>
              <FormattedHTMLMessage id='faq.hostSelling.question5.answer.part1' />
              <br />
              <br />
              <FormattedHTMLMessage id='faq.hostSelling.question5.answer.part2' />
              <br />
              <br />
              <img width='100%' src={paypalConfirmMail} alt='' />
              <br />
              <br />
              <FormattedHTMLMessage id='faq.hostSelling.question5.answer.part3' />
              <br />
              <br />
              <img width='100%' src={paypalExampleMail} alt='' />
              <br />
              <br />
              <FormattedMessage id='faq.hostSelling.question5.answer.part4' />
              <br />
              <br />
              <img width='100%' src={paypalSetting} alt='' />
            </div>
          )
        },
        {
          id: 'faq.hostSelling.question5-1.question',
          question: (
            <FormattedMessage id='faq.hostSelling.question5-1.question' />
          ),
          answer: (
            <div>
              <FormattedMessage id='faq.hostSelling.question5-1.answer' />
            </div>
          )
        },
        {
          id: 'faq.hostSelling.question6.question',
          question: (
            <FormattedMessage id='faq.hostSelling.question6.question' />
          ),
          answer: (
            <div target-name='material-with-qr'>
              <FormattedHTMLMessage id='faq.hostSelling.question6.answer' />
            </div>
          )
        },
        {
          id: 'faq.hostSelling.question7.question',
          question: (
            <FormattedMessage id='faq.hostSelling.question7.question' />
          ),
          answer: (
            <div>
              <FormattedHTMLMessage id='faq.hostSelling.question7.answer' />
            </div>
          )
        },
        {
          id: 'faq.hostSelling.question8.question',
          question: (
            <FormattedMessage id='faq.hostSelling.question8.question' />
          ),
          answer: (
            <div>
              <FormattedMessage id='faq.hostSelling.question8.answer.part1' />
              <br />
              <br />
              <FormattedMessage id='faq.hostSelling.question8.answer.part2' />
            </div>
          )
        },
        {
          id: 'faq.hostSelling.question9.question',
          question: (
            <FormattedMessage id='faq.hostSelling.question9.question' />
          ),
          answer: (
            <div>
              <FormattedHTMLMessage id='faq.hostSelling.question9.answer' />
            </div>
          )
        },
        {
          id: 'faq.hostSelling.question10.question',
          question: (
            <FormattedMessage id='faq.hostSelling.question10.question' />
          ),
          answer: (
            <div>
              <FormattedMessage id='faq.hostSelling.question10.answer' />
            </div>
          )
        },
        {
          id: 'faq.hostSelling.question11.question',
          question: (
            <FormattedMessage id='faq.hostSelling.question11.question' />
          ),
          answer: (
            <div>
              <FormattedMessage id='faq.hostSelling.question11.answer.part1' />
              <br />
              <br />
              <FormattedMessage id='faq.hostSelling.question11.answer.part2' />
              <br />
              <br />
              <FormattedMessage id='faq.hostSelling.question11.answer.part3' />
            </div>
          )
        },
        {
          id: 'faq.hostSelling.question12.question',
          question: (
            <FormattedMessage id='faq.hostSelling.question12.question' />
          ),
          answer: (
            <div>
              <FormattedMessage id='faq.hostSelling.question12.answer' />
            </div>
          )
        },
        {
          id: 'faq.hostSelling.question13.question',
          question: (
            <FormattedMessage id='faq.hostSelling.question13.question' />
          ),
          answer: (
            <div>
              <FormattedHTMLMessage id='faq.hostSelling.question13.answer' />
            </div>
          )
        },
        {
          id: 'faq.hostSelling.question14.question',
          question: (
            <FormattedMessage id='faq.hostSelling.question14.question' />
          ),
          answer: (
            <div>
              <FormattedHTMLMessage id='faq.hostSelling.question14.answer' />
            </div>
          )
        },
        {
          id: 'faq.hostSelling.question15.question',
          question: (
            <FormattedMessage id='faq.hostSelling.question15.question' />
          ),
          answer: (
            <div>
              <FormattedHTMLMessage id='faq.hostSelling.question15.answer.part1' />
              <br />
              <br />
              <FormattedHTMLMessage id='faq.hostSelling.question15.answer.part2' />
              <br />
              <br />
              <FormattedHTMLMessage id='faq.hostSelling.question15.answer.part3' />
              <br />
              <br />
              <FormattedHTMLMessage id='faq.hostSelling.question15.answer.part4' />
              <br />
              <br />
              <FormattedHTMLMessage id='faq.hostSelling.question15.answer.part5' />
            </div>
          )
        },
        {
          id: 'faq.hostSelling.question16.question',
          question: (
            <FormattedMessage id='faq.hostSelling.question16.question' />
          ),
          answer: <FormattedMessage id='faq.hostSelling.question16.answer' />
        },
        {
          id: 'faq.hostSelling.question17.question',
          question: (
            <FormattedMessage id='faq.hostSelling.question17.question' />
          ),
          answer: (
            <div>
              <FormattedMessage id='faq.hostSelling.question17.answer.part1' />
              <br />
              <br />
              <ol>
                <li>
                  <FormattedMessage id='faq.hostSelling.question17.answer.part2' />
                </li>
                <li>
                  <FormattedMessage id='faq.hostSelling.question17.answer.part3' />
                </li>
                <li>
                  <FormattedMessage id='faq.hostSelling.question17.answer.part4' />
                </li>
                <li>
                  <FormattedMessage id='faq.hostSelling.question17.answer.part5' />
                </li>
              </ol>
            </div>
          )
        }
      ]
    },
    {
      category: <FormattedMessage id='faq.categoryHeader.guestBuying' />,
      id: 'guestBuying',
      questions: [
        {
          id: 'faq.guestBuying.question1.question',
          question: (
            <FormattedMessage id='faq.guestBuying.question1.question' />
          ),
          answer: (
            <div>
              <FormattedHTMLMessage id='faq.guestBuying.question1.answer.part1' />
            </div>
          )
        },
        {
          id: 'faq.guestBuying.question2.question',
          question: (
            <FormattedMessage id='faq.guestBuying.question2.question' />
          ),
          answer: (
            <div>
              <FormattedHTMLMessage id='faq.guestBuying.question2.answer' />
            </div>
          )
        },
        {
          //   question: <FormattedMessage id='faq.guestBuying.question3.question' />,
          //   answer: <div><FormattedHTMLMessage id='faq.guestBuying.question3.answer' /></div>
          // }, {
          id: 'faq.guestBuying.question5.question',
          question: (
            <FormattedMessage id='faq.guestBuying.question5.question' />
          ),
          answer: (
            <div>
              <FormattedMessage id='faq.guestBuying.question5.answer' />
            </div>
          )
        },
        {
          id: 'faq.guestBuying.question6.question',
          question: (
            <FormattedMessage id='faq.guestBuying.question6.question' />
          ),
          answer: (
            <div>
              <FormattedHTMLMessage id='faq.guestBuying.question6.answer' />
            </div>
          )
        },
        {
          id: 'faq.guestBuying.question7.question',
          question: (
            <FormattedMessage id='faq.guestBuying.question7.question' />
          ),
          answer: (
            <div>
              <FormattedHTMLMessage id='faq.guestBuying.question7.answer' />
            </div>
          )
        },
        {
          id: 'faq.guestBuying.question8.question',
          question: (
            <FormattedMessage id='faq.guestBuying.question8.question' />
          ),
          answer: (
            <div>
              <FormattedHTMLMessage id='faq.guestBuying.question8.answer' />
            </div>
          )
        },
        {
          id: 'faq.guestBuying.question9.question',
          question: (
            <FormattedMessage id='faq.guestBuying.question9.question' />
          ),
          answer: (
            <div>
              <FormattedMessage id='faq.guestBuying.question9.answer' />
            </div>
          )
        },
        {
          id: 'faq.guestBuying.question10.question',
          question: (
            <FormattedMessage id='faq.guestBuying.question10.question' />
          ),
          answer: (
            <div>
              <FormattedHTMLMessage id='faq.guestBuying.question10.answer' />
            </div>
          )
        },
        {
          id: 'faq.guestBuying.question11.question',
          question: (
            <FormattedMessage id='faq.guestBuying.question11.question' />
          ),
          answer: (
            <div>
              <FormattedHTMLMessage id='faq.guestBuying.question11.answer' />
            </div>
          )
        },
        {
          id: 'faq.guestBuying.question12.question',
          question: (
            <FormattedMessage id='faq.guestBuying.question12.question' />
          ),
          answer: (
            <div>
              <FormattedHTMLMessage id='faq.guestBuying.question12.answer' />
            </div>
          )
        },
        {
          id: 'faq.guestBuying.question13.question',
          question: (
            <FormattedMessage id='faq.guestBuying.question13.question' />
          ),
          answer: (
            <div>
              <FormattedHTMLMessage id='faq.guestBuying.question13.answer' />
            </div>
          )
        },
        {
          id: 'faq.guestBuying.question14.question',
          question: (
            <FormattedMessage id='faq.guestBuying.question14.question' />
          ),
          answer: (
            <div>
              <FormattedHTMLMessage id='faq.guestBuying.question14.answer.part1' />
              <br />
              <br />
              <FormattedHTMLMessage id='faq.guestBuying.question14.answer.part2' />
            </div>
          )
        }
      ]
    }
  ]
}
